/**
 * @generated SignedSource<<12d963cc428807cb3a89b614503ad3db>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type initSupportChat_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"initSierraChat_user">;
  readonly " $fragmentType": "initSupportChat_user";
};
export type initSupportChat_user$key = {
  readonly " $data"?: initSupportChat_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"initSupportChat_user">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "initSupportChat_user"
};

(node as any).hash = "3ea8837f80d6181a312f8a4feb8a4ecc";

export default node;
